import { createBrowserRouter, Navigate } from "react-router-dom";
import { MarketingLayout } from "./components/MarketingLayout";
import { HomePage } from "./pages/HomePage";
import { ForHumansPage } from "./pages/ForHumansPage";
import { ForBuildersPage } from "./pages/ForBuildersPage";
import { HowItWorksPage } from "./pages/HowItWorksPage";
import { ManifestoPage } from "./pages/ManifestoPage";
import { TrustPage } from "./pages/TrustPage";
import { PrivacyPolicyPage } from "./pages/PrivacyPolicyPage";
import { TermsPage } from "./pages/TermsPage";
import { CookiePolicyPage } from "./pages/CookiePolicyPage";
import { AcceptableUsePage } from "./pages/AcceptableUsePage";
import { PricingPage } from "./pages/PricingPage";
import { RoadmapPage } from "./pages/RoadmapPage";
import { BrandPressPage } from "./pages/BrandPressPage";
import { FieldNotesIndexPage } from "./pages/FieldNotesIndexPage";
import { FieldNotesPostPage } from "./pages/FieldNotesPostPage";
import { ComingSoonPage } from "./pages/ComingSoonPage";

export const router = createBrowserRouter(
  [
    {
      element: <MarketingLayout />,
      children: [
        { path: "", element: <HomePage /> },
        // Canonical lexicon routes.
        { path: "for-humans", element: <ForHumansPage /> },
        { path: "for-builders", element: <ForBuildersPage /> },
        { path: "how-it-works", element: <HowItWorksPage /> },
        { path: "manifesto", element: <ManifestoPage /> },
        { path: "trust", element: <TrustPage /> },
        { path: "pricing", element: <PricingPage /> },
        { path: "roadmap", element: <RoadmapPage /> },
        { path: "brand", element: <BrandPressPage /> },
        { path: "notes", element: <FieldNotesIndexPage /> },
        { path: "notes/:slug", element: <FieldNotesPostPage /> },
        { path: "coming-soon", element: <ComingSoonPage /> },
        // Legacy routes redirect to canonical.
        { path: "for-annotators", element: <Navigate to="/for-humans" replace /> },
        { path: "for-requesters", element: <Navigate to="/for-builders" replace /> },
        { path: "about", element: <Navigate to="/manifesto" replace /> },
        { path: "privacy", element: <PrivacyPolicyPage /> },
        { path: "terms", element: <TermsPage /> },
        { path: "cookies", element: <CookiePolicyPage /> },
        { path: "acceptable-use", element: <AcceptableUsePage /> },
      ],
    },
  ],
  { basename: "/" }
);
